import {IClassroom, classroomInitial} from '../constants'

export const UNDATED_YEAR = 'undated'

// The API stores the ending year: 2027 means 2026–2027.
export function currentClassroomYear(now = new Date()): number {
  const date = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Istanbul', year: 'numeric', month: 'numeric',
  }).formatToParts(now)
  const year = Number(date.find(part => part.type === 'year')?.value)
  const month = Number(date.find(part => part.type === 'month')?.value)
  return year + (month >= 9 ? 1 : 0)
}

export function classroomYearKey(classroom: IClassroom): string {
  const year = Number(classroom.academicYear)
  return Number.isInteger(year) && year >= 2000 && year <= 2200 ? String(year) : UNDATED_YEAR
}

export function classroomYearOptions(classrooms: IClassroom[], currentYear: number) {
  const years = Array.from(new Set([String(currentYear), ...classrooms.map(classroomYearKey)]))
  return years.sort((a, b) => a === UNDATED_YEAR ? 1 : b === UNDATED_YEAR ? -1 : Number(b) - Number(a))
    .map(value => ({value, label: value === UNDATED_YEAR ? 'Yıl belirtilmemiş' :
      `${Number(value) - 1}–${value}${Number(value) === currentYear ? ' · Güncel' : ''}`}))
}

export function initialYearClassroom(classrooms: IClassroom[], year = currentClassroomYear()): IClassroom {
  const years = new Set(classrooms.map(classroomYearKey))
  return classrooms.find(item => classroomYearKey(item) === String(year)) ||
    (years.size === 1 ? classrooms[0] : {...classroomInitial, id: 0})
}
